module.exports = __webpack_public_path__ + "img/pr-14.9bec4f81.png";